/* import __COLOCATED_TEMPLATE__ from './train-existing-confirmation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();